export default "__VITE_ASSET__Brxa8CYx__"